import axios, { post } from 'axios';
import { baseURL, STREAM_APP_TOKEN } from '../config';

const jwtToken = localStorage.getItem('JWT_TOKEN');
const REQUEST_TIMEOUT = 60000;
const headers = {
    'Content-Type': 'application/json',
};
const uploadConfig = {
    headers: {
        Accept: '*/*',
    },
};

if (jwtToken) {
    headers.Authorization = `Bearer ${jwtToken}`;
}

let fetcher = axios.create({
    timeout: REQUEST_TIMEOUT,
    baseURL: baseURL + '/v1/',
    headers,
});

let fetcherV2 = axios.create({
    timeout: REQUEST_TIMEOUT,
    baseURL: baseURL + '/v2/',
    headers,
});

export const defineJwt = (jwt) => {
    localStorage.setItem('JWT_TOKEN', jwt);

    fetcher = axios.create({
        timeout: REQUEST_TIMEOUT,
        baseURL: baseURL + '/v1/',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${jwt}`,
            'STREAM-APP-TOKEN': STREAM_APP_TOKEN,
            Accept: '*/*',
        },
    });

    fetcherV2 = axios.create({
        timeout: REQUEST_TIMEOUT,
        baseURL: baseURL + '/v2/',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${jwt}`,
            'STREAM-APP-TOKEN': STREAM_APP_TOKEN,
            Accept: '*/*',
        },
    });
};

export const apiPost = (...args) => fetcher.post(...args);
export const apiPostV2 = (...args) => fetcherV2.post(...args);

export const apiGet = (...args) => fetcher.get(...args);
export const apiGetV2 = (...args) => fetcherV2.get(...args);

export const apiPut = (...args) => fetcher.put(...args);
export const apiPutV2 = (...args) => fetcherV2.put(...args);

export const apiDelete = (...args) => fetcher.delete(...args);
export const apiDeleteV2 = (...args) => fetcherV2.delete(...args);

export const apiPatch = (...args) => fetcher.patch(...args);
export const apiPatchV2 = (...args) => fetcherV2.patch(...args);

export const apiUpload = (url, payload, onProgress) => {
    return post(url, payload, { ...uploadConfig, onUploadProgress: onProgress });
};
